<template>
  <portal to="modal-destination">
    <Moveable
      class="moveable"
      v-bind="moveable"
      @drag="onDrag"
      @dragStart="onDragStart"
      @dragEnd="onDragEnd"
      @resize="onResize"
      @resizeStart="onResizeStart"
      @resizeEnd="onResizeEnd"
      target="#modal-video-tutorial"
    />
    <div id="modal-video-tutorial" class="modal-video-tutorial">
      <div class="flex flex-row justify-between modal-close ">
        <aha-icon
          name="arrow-left"
          @click="$emit('back')"
          class="mb-1"
        ></aha-icon>
        <button @click="$emit('hide')">
          <i class="fas fa-times fa-fw"></i>
        </button>
      </div>
      <iframe
        ref="iframeRef"
        width="1048.89"
        height="600"
        class="w-full h-full object-cover"
        :src="srcTutorial(video.snippet.resourceId.videoId)"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      >
      </iframe>
    </div>
  </portal>
</template>
<script>
import Moveable from 'vue-moveable'
import utils from '@/util'
import constants from '@/constant'

export default {
  components: {
    Moveable,
  },
  props: {
    video: {
      type: Object,
      default: () => ({}),
    },

  },
  data: () => ({
    moveable: {
      draggable: true,
      throttleDrag: 1,
      resizable: true,
      throttleResize: 1,
      keepRatio: true,
      scalable: false,
      throttleScale: 0.01,
      rotatable: false,
      throttleRotate: 0.2,
      pinchable: false,
      origin: false,

    },
  }),
  methods: {
    onDrag({ target, transform }) {
      target.style.transform = transform
    },
    onDragStart() {
      this.$refs.iframeRef.style.pointerEvents = 'none'
    },
    srcTutorial: (videoId) => {
      return `https://www.youtube.com/embed/${videoId}?rel=0`
    },
    onDragEnd({ isDrag }) {
      this.$refs.iframeRef.style.pointerEvents = 'auto'

      if (isDrag) {
        utils.mixpanelTracking(
          constants.eventCategories.PRESENTATION_EDITOR,
          'Video tutorial > Drag video',
          this.$store.state.slideActive.type,
        )
      }
    },
    onResize({
      target, width, height, drag,
    }) {
      target.style.width = `${width}px`
      target.style.height = `${height}px`
      target.style.transform = `${drag.transform}`
    },
    onResizeStart() {
      this.$refs.iframeRef.style.pointerEvents = 'none'
      this.$refs.modalRef.classList.add('resizing')
    },
    onResizeEnd() {
      this.$refs.iframeRef.style.pointerEvents = 'auto'
      this.$refs.modalRef.classList.remove('resizing')
    },
  },
}

</script>
<style lang="scss" scoped>
.modal-video-tutorial {
  position: fixed;
  z-index: 9;
  filter: drop-shadow(0px 14px 46px rgba(0, 0, 0, 0.1));
  border-radius: 4px;
  cursor: all-scroll;
  width: 649px;
  top:50%;
  left:50%;

  &.resizing {
    background-color: #fff;
  }
  svg{
    cursor: pointer;
  }
  &:hover {
    background-color: #fff;

    .modal-close {
      width:100%;
      visibility: visible;
    }

  }

  .modal-close {
    visibility: hidden;
    padding: 8px 8px 2px 10px;
    position: absolute;
    right: 0;
    top: 0;
    background-color: transparent;
    color: #AFAFAF;
    font-size: 13px;

    &:focus {
      border: none;
      outline: 0;
    }

    &:hover {
      color: #191F2D;
      svg{
        fill:#191F2D!important;
        color: #191F2D;
      }
    }
  }

  iframe {
    width: 100%;
    height: 100%;
    aspect-ratio: 16 / 9;
    padding: 30px 10px 10px 10px;
  }
}

#modal-destination {
  .moveable-control-box {
    opacity: 0;

    &:hover ~ .modal-video-tutorial {
      background-color: #fff;
    }

    .moveable-control {
      width: 24px;
      height: 24px;
      margin-top: -12px;
      margin-left: -12px;
    }
  }
}
</style>
